import React, { memo, useCallback, useState } from 'react';
import { EditIcon } from '@ui/components';
import { ICity, deleteCity as deleteCityApi } from '@ui/api/v2/cities.api';
import { Modal, notification } from 'antd';
import { replaceSpaceByDash } from '../../utils/helpers';

interface IProps {
  city: ICity;
  setEditCity: (city: ICity) => void;
  onDelete: (id: number) => void;
}

function CityCard({ city, setEditCity, onDelete }: IProps) {
  const [showModal, setShowModal] = useState(false);
  const onEditClick = useCallback(() => {
    setEditCity(city);
  }, [city, setEditCity]);

  const deleteCity = useCallback(async () => {
    setShowModal(false);
    const { error } = await deleteCityApi(city.id);
    if (error) {
      notification.error({
        message: error.response.data.message,
      });
    } else {
      onDelete(city.id);
    }
  }, [city.id, onDelete, setShowModal]);

  return (
    <div className="cities__item">
      <span>{replaceSpaceByDash(city.name)}</span>
      <span>{city.region.name}</span>
      <span />
      <div className="cities__controls">
        <EditIcon onClick={onEditClick} type="edit" />
        <EditIcon onClick={() => setShowModal(true)} type="remove" />
      </div>
      <Modal
        okButtonProps={{
          style: {
            width: '120px',
          },
          size: 'large',
          type: 'danger',
        }}
        cancelButtonProps={{
          style: {
            width: '120px',
          },
          size: 'large',
          type: 'primary',
        }}
        okText="Да"
        cancelText="Нет"
        title="Удаление города"
        visible={showModal}
        onOk={deleteCity}
        onCancel={() => setShowModal(false)}
      >
        <p>Вы уверены, что ходите удалить город {city.name}</p>
      </Modal>
    </div>
  );
}

export default memo(CityCard);



// WEBPACK FOOTER //
// ./src/components/Cities/CityCard.tsx